/*
  Papel e sessão vêm do ApplicationContext (GET /me), não de decodificar o
  JWT aqui — o token carrega uma cópia do staff feita no login e ficaria
  desatualizado por até um dia. Aqui ficam o logout e os grupos de papéis de
  cada área, que espelham as guardas do servidor (admin/middlewares/withActor.js)
  e só decidem o que aparece: quem autoriza de verdade é o servidor.
*/

export const ADMIN_ONLY = ["ADMIN"];
export const ADMIN_OR_OPERATOR = ["ADMIN", "OPERATOR"];
// Clientes, Minha carteira e Funil.
export const WITH_CLIENT_ACCESS = ["ADMIN", "ACCOUNT_MANAGER"];

export const removeToken = () => {
  localStorage.removeItem("token");
  window.location.href = "/login";
};
